<script>
import { isEmpty } from 'lodash'
import userHasRolesToWrite from '@utils/userPermissions'

export default {
  name: 'GoodsEquippedbarrel',
  props: {
    equippedbarrel: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        drumOil: null,
        plug: null,
      },
      rules: {
        drumOil: [x => !!x || this.$t('validation__is_required')],
        plug: [x => !!x || this.$t('validation__is_required')],
      },
      rolesAllowedToWrite: ['SUPERUSER', 'DICTIONARIES_OPERATOR'],
    }
  },
  computed: {
    drumOil() {
      return this.$store.getters['data/getDictionary']('goods')
    },
    plug() {
      return this.$store.getters['data/getDictionary']('goods')
    },
    isNew() {
      return isEmpty(this.equippedbarrel)
    },
    userAllowedToUpdate() {
      return userHasRolesToWrite(
        this.$store.state.auth.userRole,
        this.rolesAllowedToWrite
      )
    },
  },
  created() {
    Object.assign(this.item, this.equippedbarrel)
  },
}
</script>

<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex lg4>
        <v-form ref="drumoilForm" v-model="valid" lazy-validation>
          <v-select
            :items="drumOil"
            :label="$t('label__article')"
            v-model="item.drumOil"
            :rules="rules.drumOil"
            item-text="shortName"
            item-value="id"
            readonly
          />
          <v-select
            :items="plug"
            :label="$t('label__plug')"
            v-model="item.plug"
            :rules="rules.plug"
            item-text="shortName"
            item-value="id"
            readonly
          />
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin: 10px -7px;
}
</style>
